import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import Column from '../Column';


export default /*@__PURE__*/_defineComponent({
  __name: 'LinkColumn',
  props: {
    column: {},
    row: {}
  },
  setup(__props: any) {

const props = __props;

const to = computed(() => props.column.getTo(props.row) || '/');

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_component_RouterLink, {
    class: "table-link",
    to: to.value
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.column.render(__props.row)), 1)
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})